const faqItems = [
  {
    q: '夜猫电影院需要注册会员才能观看吗？',
    a: '完全不需要！夜猫电影院所有高清电影和免费电视剧均无需注册，打开即播，不卡顿不缓冲，真正实现零门槛观影体验。',
  },
  {
    q: '为什么选择夜猫电影院而不是其他免费影院？',
    a: '夜猫电影院拥有10万+高清片源库，采用独家秒播技术确保播放流畅不卡顿。每日实时同步最新电影和热门剧集，画质清晰色彩饱满，是熬夜追剧爱好者的首选免费影院。',
  },
  {
    q: '夜猫电影院的视频画质怎么样？',
    a: '我们提供真正的高清画质影视内容，支持多线路切换自动选择最优播放节点。无论是最新院线大片还是经典电影大全，都能享受不亚于付费平台的高清影视体验。',
  },
  {
    q: '手机和平板能看夜猫电影院吗？',
    a: '当然可以！夜猫电影院完美适配手机、平板、电脑等全终端设备，无论在家用大屏还是通勤路上用手机，都能享受高清秒播不卡顿的观影乐趣。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
          关于夜猫电影院的常见疑问，这里为您一一解答
        </p>

        <div className="space-y-4">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100/70 border border-background-200/60 rounded-xl p-5 md:p-6 transition-colors duration-200 hover:border-primary-200/50"
            >
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-xs font-bold mt-0.5">
                  Q
                </span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-9">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}